/**
 * Global
 * ------
 */

function mobileMinHeight() {
    if($(window).width() < 992) {
        $('.mobile-min-height').each(function() {
            var minheight = $(this).find('.img-overlay').height();

            $(this).find('.bg-img').css('min-height', minheight+120);
        });
    }
}

$(window).on('resize', function() {
    mobileMinHeight();
}).trigger('resize');